type PrintPeriodLayoutInput = {
  startX: number | null
  endX: number | null
  startWidth: number
  endWidth: number
  chartWidth: number
}

const LABEL_GAP = 4

export const placePrintPeriodLabels = (input: PrintPeriodLayoutInput) => {
  const { startX, endX, startWidth, endWidth, chartWidth } = input
  const clampLeft = (left: number, width: number) =>
    Math.max(0, Math.min(left, chartWidth - width))

  let startLeft = clampLeft(startX ?? 0, startWidth)
  let endLeft = clampLeft((endX ?? 0) - endWidth, endWidth)

  if (
    startX != null &&
    endX != null &&
    startLeft + startWidth + LABEL_GAP > endLeft
  ) {
    // Resolve collisions using the final, bounded boxes. Changing the direction
    // of a label after measuring the overlap can put it back over the other one.
    endLeft = clampLeft(startLeft + startWidth + LABEL_GAP, endWidth)
    startLeft = Math.max(
      0,
      Math.min(startLeft, endLeft - LABEL_GAP - startWidth),
    )
  }

  return { startLeft, endLeft }
}
